/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_TaglineInputs */

const en_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomous agents that plan, use tools, and get real work done, not chatbots.`)
};

const ar_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكلاء مستقلون يخططون ويستخدمون الأدوات ويُنجزون أعمالًا حقيقية، ليست مجرد بوتات محادثة.`)
};

const bn_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোনোমাস এজেন্ট যারা পরিকল্পনা করে, টুল ব্যবহার করে এবং আসল কাজ শেষ করে, চ্যাটবট নয়।`)
};

const de_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonome Agenten, die planen, Tools verwenden und echte Arbeit erledigen, keine Chatbots.`)
};

const es_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes autónomos que planifican, utilizan herramientas y realizan trabajo real, no chatbots.`)
};

const fr_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des agents autonomes qui planifient, utilisent des outils et accomplissent un vrai travail, pas des chatbots.`)
};

const pt_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes autônomos que planejam, usam ferramentas e realizam trabalho real, não chatbots.`)
};

const zh_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`规划、使用工具并完成实际工作的自主代理，而不是聊天机器人。`)
};

const tr_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatbot değil, planlayan, araç kullanan, gerçek iş bitiren otonom ajanlar.`)
};

const ru_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автономные агенты, которые планируют, используют инструменты и выполняют реальную работу, а не чат-боты.`)
};

const pl_svc_ai_agent_development_tagline = /** @type {(inputs: Svc_Ai_Agent_Development_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomiczni agenci, którzy planują, korzystają z narzędzi i wykonują prawdziwą pracę, a nie chatboty.`)
};

/**
* | output |
* | --- |
* | "Autonomous agents that plan, use tools, and get real work done, not chatbots." |
*
* @param {Svc_Ai_Agent_Development_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_tagline = /** @type {((inputs?: Svc_Ai_Agent_Development_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_tagline(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_tagline(inputs)
	if (locale === "de") return de_svc_ai_agent_development_tagline(inputs)
	if (locale === "es") return es_svc_ai_agent_development_tagline(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_tagline(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_tagline(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_tagline(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_tagline(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_tagline(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_tagline(inputs)
	return en_svc_ai_agent_development_tagline(inputs)
});
export { svc_ai_agent_development_tagline as "svc_ai-agent-development_tagline" }